/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type DepartmentType = "AdmissionSource" | "Unit" | "%future added value";
export type SearchType = "ADMITS" | "ATTENTION" | "BARRIER" | "DISCHARGE" | "ESCALATIONS" | "LOS_REVIEW" | "PATIENT" | "PROGRESSION" | "VARIANCE" | "VISIT" | "%future added value";
export type NavigatorWorkspacesQueryVariables = {|
  type?: ?SearchType,
  query?: ?string,
|};
export type NavigatorWorkspacesQueryResponse = {|
  +viewer: {|
    +beds: {|
      +totalCount: number,
      +pageInfo: {|
        +endCursor: ?string,
        +hasNextPage: boolean,
        +hasPreviousPage: boolean,
        +startCursor: ?string,
        +totalCount: string,
      |},
      +edges: $ReadOnlyArray<{|
        +bed: {|
          +id: string,
          +name: string,
          +exchangeName: string,
          +status: string,
          +conflictingVisits: $ReadOnlyArray<{|
            +id: string
          |}>,
          +dischargedVisits: ?$ReadOnlyArray<?{|
            +id: string,
            +patient: {|
              +id: string,
              +age: ?string,
              +firstName: ?string,
              +gender: ?string,
              +lastName: ?string,
              +middleInitial: ?string,
              +mrn: ?string,
            |},
            +plan: ?{|
              +id: string,
              +careTeamMembers: $ReadOnlyArray<?{|
                +id: string,
                +primary: ?boolean,
              |}>,
            |},
            +attendingPhysician: ?{|
              +firstName: ?string,
              +id: string,
              +lastName: ?string,
            |},
            +provider1: ?{|
              +id: string,
              +firstName: ?string,
              +lastName: ?string,
              +role: {|
                +code: ?string,
                +id: string,
                +value: ?string,
              |},
            |},
          |}>,
          +department: {|
            +id: string,
            +exchangeName: string,
            +name: string,
            +type: DepartmentType,
            +includedInLosCalculation: boolean,
          |},
          +visit: ?{|
            +id: string,
            +attendingPhysician: ?{|
              +firstName: ?string,
              +id: string,
              +lastName: ?string,
              +primary: boolean,
              +role: {|
                +code: ?string,
                +id: string,
                +value: ?string,
              |},
            |},
            +patient: {|
              +id: string,
              +age: ?string,
              +firstName: ?string,
              +gender: ?string,
              +lastName: ?string,
              +middleInitial: ?string,
              +mrn: ?string,
            |},
            +provider1: ?{|
              +id: string,
              +firstName: ?string,
              +lastName: ?string,
              +role: {|
                +code: ?string,
                +id: string,
                +value: ?string,
              |},
            |},
            +provider2: ?{|
              +id: string,
              +firstName: ?string,
              +lastName: ?string,
              +role: {|
                +code: ?string,
                +id: string,
                +value: ?string,
              |},
            |},
            +plan: ?{|
              +id: string,
              +careTeamMembers: $ReadOnlyArray<?{|
                +id: string,
                +name: ?string,
                +role: {|
                  +id: string,
                  +code: ?string,
                  +value: ?string,
                |},
                +primary: ?boolean,
              |}>,
            |},
          |},
        |}
      |}>,
    |}
  |}
|};
export type NavigatorWorkspacesQuery = {|
  variables: NavigatorWorkspacesQueryVariables,
  response: NavigatorWorkspacesQueryResponse,
|};
*/


/*
query NavigatorWorkspacesQuery(
  $type: SearchType
  $query: String
) {
  viewer {
    beds(first: 100000, type: $type, query: $query) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
        totalCount
      }
      edges {
        bed: node {
          id
          name
          exchangeName
          status
          conflictingVisits {
            id
          }
          dischargedVisits {
            id
            patient {
              id
              age
              firstName
              gender
              lastName
              middleInitial
              mrn
            }
            plan {
              id
              careTeamMembers {
                id
                primary
              }
            }
            attendingPhysician {
              firstName
              id
              lastName
            }
            provider1 {
              id
              firstName
              lastName
              role {
                code
                id
                value
              }
            }
          }
          department {
            id
            exchangeName
            name
            type
            includedInLosCalculation
          }
          visit {
            id
            attendingPhysician {
              firstName
              id
              lastName
              primary
              role {
                code
                id
                value
              }
            }
            patient {
              id
              age
              firstName
              gender
              lastName
              middleInitial
              mrn
            }
            provider1 {
              id
              firstName
              lastName
              role {
                code
                id
                value
              }
            }
            provider2 {
              id
              firstName
              lastName
              role {
                code
                id
                value
              }
            }
            plan {
              id
              careTeamMembers {
                id
                name
                role {
                  id
                  code
                  value
                }
                primary
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "query"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "exchangeName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firstName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "Patient",
  "kind": "LinkedField",
  "name": "patient",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "age",
      "storageKey": null
    },
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "middleInitial",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mrn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primary",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "CodeTablePair",
  "kind": "LinkedField",
  "name": "role",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    (v3/*: any*/),
    (v11/*: any*/)
  ],
  "storageKey": null
},
v13 = [
  (v3/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v12/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "PersonnelRole",
  "kind": "LinkedField",
  "name": "provider1",
  "plural": false,
  "selections": (v13/*: any*/),
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "first",
            "value": 100000
          },
          {
            "kind": "Variable",
            "name": "query",
            "variableName": "query"
          },
          {
            "kind": "Variable",
            "name": "type",
            "variableName": "type"
          }
        ],
        "concreteType": "BedConnection",
        "kind": "LinkedField",
        "name": "beds",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "BedEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": "bed",
                "args": null,
                "concreteType": "Bed",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "status",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Visit",
                    "kind": "LinkedField",
                    "name": "conflictingVisits",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Visit",
                    "kind": "LinkedField",
                    "name": "dischargedVisits",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Plan",
                        "kind": "LinkedField",
                        "name": "plan",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CareTeamMember",
                            "kind": "LinkedField",
                            "name": "careTeamMembers",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonnelRole",
                        "kind": "LinkedField",
                        "name": "attendingPhysician",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Department",
                    "kind": "LinkedField",
                    "name": "department",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v5/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "includedInLosCalculation",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Visit",
                    "kind": "LinkedField",
                    "name": "visit",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonnelRole",
                        "kind": "LinkedField",
                        "name": "attendingPhysician",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v3/*: any*/),
                          (v7/*: any*/),
                          (v9/*: any*/),
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PersonnelRole",
                        "kind": "LinkedField",
                        "name": "provider2",
                        "plural": false,
                        "selections": (v13/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Plan",
                        "kind": "LinkedField",
                        "name": "plan",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CareTeamMember",
                            "kind": "LinkedField",
                            "name": "careTeamMembers",
                            "plural": true,
                            "selections": [
                              (v3/*: any*/),
                              (v4/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "CodeTablePair",
                                "kind": "LinkedField",
                                "name": "role",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v9/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "NavigatorWorkspacesQuery",
    "selections": (v15/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "NavigatorWorkspacesQuery",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "89b65632a34f9b1e312b4c4b50aa69f5",
    "id": null,
    "metadata": {},
    "name": "NavigatorWorkspacesQuery",
    "operationKind": "query",
    "text": "query NavigatorWorkspacesQuery(\n  $type: SearchType\n  $query: String\n) {\n  viewer {\n    beds(first: 100000, type: $type, query: $query) {\n      totalCount\n      pageInfo {\n        endCursor\n        hasNextPage\n        hasPreviousPage\n        startCursor\n        totalCount\n      }\n      edges {\n        bed: node {\n          id\n          name\n          exchangeName\n          status\n          conflictingVisits {\n            id\n          }\n          dischargedVisits {\n            id\n            patient {\n              id\n              age\n              firstName\n              gender\n              lastName\n              middleInitial\n              mrn\n            }\n            plan {\n              id\n              careTeamMembers {\n                id\n                primary\n              }\n            }\n            attendingPhysician {\n              firstName\n              id\n              lastName\n            }\n            provider1 {\n              id\n              firstName\n              lastName\n              role {\n                code\n                id\n                value\n              }\n            }\n          }\n          department {\n            id\n            exchangeName\n            name\n            type\n            includedInLosCalculation\n          }\n          visit {\n            id\n            attendingPhysician {\n              firstName\n              id\n              lastName\n              primary\n              role {\n                code\n                id\n                value\n              }\n            }\n            patient {\n              id\n              age\n              firstName\n              gender\n              lastName\n              middleInitial\n              mrn\n            }\n            provider1 {\n              id\n              firstName\n              lastName\n              role {\n                code\n                id\n                value\n              }\n            }\n            provider2 {\n              id\n              firstName\n              lastName\n              role {\n                code\n                id\n                value\n              }\n            }\n            plan {\n              id\n              careTeamMembers {\n                id\n                name\n                role {\n                  id\n                  code\n                  value\n                }\n                primary\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4e26adc0a47cd4d8e0671a07eb65e88b';

module.exports = node;
